import React from 'react';
import { Link } from 'react-router-dom';
import { Construction, ArrowLeft } from 'lucide-react';

/**
 * Portal Placeholder Page - Phase 6
 * 
 * Generic placeholder for portal pages that are coming soon.
 */
const PortalPlaceholder = ({ title, description, backLink, backLabel }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] text-center px-4">
      <div className="w-20 h-20 rounded-full bg-slate-100 flex items-center justify-center mb-6">
        <Construction className="text-slate-400" size={40} />
      </div>
      <h2 className="text-2xl font-bold text-stone-900 mb-2">{title || 'Coming Soon'}</h2>
      <p className="text-slate-500 max-w-md mb-6">
        {description || 'This feature is being built and will be available soon.'}
      </p>
      {backLink && (
        <Link
          to={backLink}
          className="inline-flex items-center gap-2 px-4 py-2 bg-stone-900 text-white rounded-lg hover:bg-stone-800 transition-colors"
        >
          <ArrowLeft size={18} />
          <span>{backLabel || 'Go Back'}</span>
        </Link>
      )}
    </div>
  );
};

export default PortalPlaceholder;
